export function getFileSize(size: number) {
  const fileSize = (size / (1024 * 1024)).toFixed(2);
  return `${fileSize} MB`;
}